import { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  reloadCustomizableCloset,
  increaseAnticipatedAddOnCount,
  decreaseAnticipatedAddOnCount,
  changeAnticipatedAddOnError,
  addSelectedItemToCloset,
  putSelectedItemInCloset,
  removeSelectedItemFromCloset,
  validateCurrentCloset,
  currentClosetBackToRTC,
} from "@actions/customizable-closet-actions";

const useCustomizableCloset = () => useSelector((state) => state.customizableCloset.currentCloset);

export function useIncreaseAnticipatedAddOnCount() {
  const dispatch = useDispatch();

  return () => dispatch(increaseAnticipatedAddOnCount());
}

export function useDecreaseAnticipatedAddOnCount() {
  const dispatch = useDispatch();

  return () => dispatch(decreaseAnticipatedAddOnCount());
}

export function useAnticipatedAddOnCount() {
  return useSelector((store) => store.customizableCloset.anticipatedAddOnCount);
}

export function useAnticipatedAddOnError() {
  return useSelector((store) => store.customizableCloset.anticipatedAddOnError);
}

export function useChangeAnticipatedAddOnError() {
  const dispatch = useDispatch();

  return (newError) => dispatch(changeAnticipatedAddOnError(newError));
}

export function useReloadCustomizableCloset() {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(reloadCustomizableCloset());
  }, [dispatch]);
}

export function useAddSelectedItemToCloset() {
  const dispatch = useDispatch();

  return async (selectedVariant) => dispatch(addSelectedItemToCloset(selectedVariant));
}

export function usePutSelectedItemInCloset() {
  const dispatch = useDispatch();

  return async (selectedItemId, selectedVariant) =>
    dispatch(putSelectedItemInCloset(selectedItemId, selectedVariant));
}

export function useRemoveSelectedItemFromCloset() {
  const dispatch = useDispatch();

  return async (selectedItemId) => dispatch(removeSelectedItemFromCloset(selectedItemId));
}

export function useValidateCurrentCloset() {
  const dispatch = useDispatch();

  return async (options) => dispatch(validateCurrentCloset(options));
}

export function useCurrentClosetBackToRTC() {
  const dispatch = useDispatch();

  return async () => dispatch(currentClosetBackToRTC());
}

export default useCustomizableCloset;
